<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { EMBEDDED_COMPONENTS } from '../general/embedded-constants';
import useSubscriptionStore from '../store/subscriptions';
import useAccountStore from '../store/account';
import { STRIPE_STATUS } from '../constants/constants';
import { URL_CUSTOMER_PORTAL_CONNECTED } from '../../../_00_elements/tools/routes/routes';
import ManageOnboarding from './ManageOnboarding.vue';
import { trans } from '../../../_00_elements/translation';
import Typography from '../../../_01_atoms/components/Typography.vue';

const isMobile = ref(false);
const step = ref(2);
const accountStore = useAccountStore();
const subscriptionStore = useSubscriptionStore();

const checkIsMobile = () => {
  isMobile.value = window.BREAKPOINTS.isMobile;
};
const nextStep = () => {
  step.value++;
};

const fetchClientSecret = async (accountToken = '') => {
  await subscriptionStore.getOnboardingClientSecret(accountToken);
  return subscriptionStore.onboardingClientSecret;
};

onMounted(async () => {
  if (accountStore.hasBillingInformations && accountStore.stripeAccountStatus === STRIPE_STATUS.ACTIVE) {
    step.value = accountStore.hasBillingInformations ? 3 : 2;
  }

  // @TODO Centralize in pinia store, see  https://bureaux-a-partager.atlassian.net/browse/MATCH-9839
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);

  if (accountStore.stripeAccountStatus !== STRIPE_STATUS.ACTIVE) {
    step.value = 1;

    try {
      const accountToken = await subscriptionStore.createAccountToken();
      const clientSecret = await fetchClientSecret(accountToken);

      const stripeConnectInstance = await loadConnectAndInitialize({
        publishableKey: window.STRIPE_API_KEY,
        fetchClientSecret: () => clientSecret,
      });

      const onboardingComponent = await stripeConnectInstance.create(
        EMBEDDED_COMPONENTS.ACCOUNT_ONBOARDING,
      );

      onboardingComponent.addEventListener('exit', async () => {
        step.value = accountStore.hasBillingInformations ? 3 : 2;
      });

      const container = document.getElementById('connect-onboarding');
      if (container) {
        container.style.width = '100%';
        container.style.height = '800px';
        container.appendChild(onboardingComponent);
      }
    } catch {
      console.error('Error while openning stripe'); // eslint-disable-line no-console
    }
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});
</script>
<template>
  <div class="app-subscription">
    <div v-if="step === 1" class="app-subscription__content stripe-onboarding">
      <div id="connect-onboarding" />
    </div>
    <ManageOnboarding v-if="step === 2" @next-step="nextStep" />
    <div v-if="step === 3" class="invoicing-payment-method">
      <Typography
        variant="body-bold"
      >
        {{ trans('gestion.pay.informations.payment_method.title') }}
      </Typography>

      <Typography
        class="invoicing-payment-method__text"
        variant="body-small"
        color="gray-darker"
      >
        {{ trans('gestion.pay.informations.payment_method.text', { company_name: $companyName }) }}
      </Typography>
      <a :href="URL_CUSTOMER_PORTAL_CONNECTED" target="_blank" class="btn btn--primary">
        {{ trans('gestion.pay.informations.payment_method.button') }}
      </a>
    </div>
  </div>
</template>
